// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__hJfpQ","content":"LayoutSettings_content__lfNVW"};